export default __webpack_public_path__ + "static/media/english-to-portuguese-screenshot-02.40f2dbb4.png";